<script>
export default {
  components: {}
};
</script>

<style scoped>

#auth-container {
  /* background-image: url('~@/assets/images/cab/background/back.jpg');  */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: local;
  height: 1080px;
}

@media all and (max-width: 400px) {
    #auth-container {
    } 
}

@media all and (min-width: 401px) {
    #auth-container {
}

}

  @media all and (min-width: 1390px) {
    #auth-container {
        zoom: 100%;
    } 
  }

    @media all and (max-width: 1390px) {
    #auth-container {
        zoom: 70%;
    } 

    }

  @media all and (max-width: 800px) {
    #auth-container {
        zoom: 50%;
    } 
  }

  @media screen and (max-width: 500px) {
  #auth-container {
        zoom: 100%;
    } 
  }



</style>

<template>
  <div id="auth-container" class="" style="" >
    <vue-snotify></vue-snotify>
        <slot />
  </div>
</template>
